import fileSaver from 'lib/file-saver';
import {
  DOWNLOAD_ORDER_HISTORY_EXCEL, CLIENT_ERROR_RESPONSES, ABORT_ERROR, SUCCESS_RESPONSES,
  SERVER_ERROR_RESPONSES,
} from '../constants/AppConstants';

export default async (requestBody, signal) => {
  try {
    const response = await fetch(DOWNLOAD_ORDER_HISTORY_EXCEL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
      signal,
    });

    if (response.status !== SUCCESS_RESPONSES.SUCCESS_OK) return { ok: false, status: response.status };

    // Extract filename from header
    const contentDispositionHeader = response.headers.get('Content-Disposition');
    // #genai Preserve the original null/empty-header short-circuit without an incomplete optional chain.
    const filename = contentDispositionHeader
      ? contentDispositionHeader.split(';')
        .find((n) => n.includes('filename='))
        .replace('filename=', '')
        .trim()
      : contentDispositionHeader;

    const blob = await response.blob();

    // Download the file
    fileSaver.saveAs(blob, filename);

    return { ok: true, status: response.status };
  } catch (error) {
    const status = error.name === ABORT_ERROR ? CLIENT_ERROR_RESPONSES.STATUS_ABORT_REQUEST : SERVER_ERROR_RESPONSES.INTERNAL_SERVER_ERROR;
    return { ok: false, status };
  }
};
